const formatMoney = value => {
    const newValue = !String(value).includes('.') ? `${value}.00` : String(value)
    const valSplit = newValue.split('.')

    return {
        dollars: parseInt(valSplit[0].replace(',', ''), 10),
        cents: parseInt(valSplit[1], 10),
    }
}

/* eslint-disable max-len */
export const urlRegex = /^(?!.*%(?![\da-f]{2}))(?:https?:\/\/)(?:www\.)?[a-z\d]+(?:[.-][a-z\d]+)*\.[a-z]{2,6}(?::\d{1,5})?(?:\/\S*)?$/i

export const videoUrlRegex = /^(https:\/\/|)(vimeo\.com|youtu\.be|www\.youtube\.com|youtube\.com|player\.vimeo\.com)\/(.*)?$/

export const slugRegex = /^[a-z0-9-]+$/

export const fieldRegex = /^[a-zA-Z0-9-_]+$/

export const moneyMin = {
    validate: (value, args) => {
        if (args.unless && value === args.unless) return true
        const moneyInput = formatMoney(value)
        const moneyMinimum = formatMoney(args.min)

        if (moneyInput.dollars > moneyMinimum.dollars) {
            return true
        }

        if (moneyInput.dollars === moneyMinimum.dollars) {
            return moneyInput.cents >= moneyMinimum.cents
        }

        return false
    },
    params: [ 'min', 'unless' ],
}

export const moneyMax = {
    validate: (value, args) => {
        if (args.unless && value === args.unless) return true
        if (args.max == null) return true
        const moneyInput = formatMoney(value)
        const moneyMaximum = formatMoney(args.max)

        if (moneyInput.dollars < moneyMaximum.dollars) {
            return true
        }

        if (moneyInput.dollars === moneyMaximum.dollars) {
            return moneyInput.cents <= moneyMaximum.cents
        }

        return false
    },
    params: [ 'max', 'unless' ],
}

export const moneyMinValue = {
    validate: (value, args) => {
        if (args.unless && Number(value) === Number(args.unless)) return true

        return Number(value) >= Number(args.min)
    },
    params: [ 'min', 'unless' ],
}

const isSet = value => value !== undefined && value !== null

export const requiredWith = {
    validate(value, { other }) {
        return {
            valid: !isSet(other) || isSet(value),
            data: {
                required: true,
            },
        };
    },
    params: [ 'other' ],
    computesRequired: true,
    message: '{_field_} is required when {other} is set',
}
